import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { LibrariesPage } from '@/features/access/libraries/libraries-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/libraries/')({ component: LibrariesRoute });

function LibrariesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="libraries" crumbs={[{ label: t('access.libraries.title') }]}>
      <LibrariesPage tenantId={tenant} />
    </ConsoleShell>
  );
}
